import { usePushNotifications } from '../../data/hooks/pushNotifications';
import { useLastUpdate } from '../../data/hooks/sessionHooks';

export function useStoredDataChanged() {
    useLastUpdate();
    usePushNotifications();
}
